import gsap from "gsap";

export default class ContactStrip {
	constructor(el) {
		this.el = el;
		this.tl = gsap.timeline();
		this.init();
	}

	init() {
		this.toggleBtn = this.el.querySelector(".contact-strip-toggle-btn");
		this.dropdownWrapper = this.el.querySelector(".contact-strip-dropdown-wrapper");
		this.dropdown = this.el.querySelector(".contact-strip-dropdown");
		this.toggleBtn.addEventListener("click", this.toggleDropdown);
	}

	toggleDropdown = (e) => {
		this.isOpen = this.toggleBtn.getAttribute("aria-expanded") === "true";
		if (this.isOpen) {
			// close
			this.closeDropdown();
		} else {
			// open
			this.openDropdown();
		}
	};

	closeDropdown() {
		this.toggleBtn.setAttribute("aria-expanded", false);
		this.tl
			.fromTo(
				this.dropdown,
				{ y: 0, autoAlpha: 1 },
				{ y: -10, autoAlpha: 0, duration: 0.25, ease: "power3.inOut" }
			)
			.set(this.dropdownWrapper, { css: { display: "none" } });
	}

	openDropdown() {
		this.toggleBtn.setAttribute("aria-expanded", true);
		this.tl
			.set(this.dropdownWrapper, { css: { display: "block" } })
			.fromTo(
				this.dropdown,
				{ y: -10, autoAlpha: 0 },
				{ y: 0, autoAlpha: 1, duration: 0.25, ease: "power3.inOut" }
			);
	}
}
